module.exports = __webpack_public_path__ + "static/media/Sports.d9093b70.png";